import * as React from "react";
import { MapContainer } from "react-leaflet";
import { isBrowser } from "../../../../utils/helpers";
import { styledMap, hotelEmpty } from "./SearchMap.module.scss";

export const StyledMap: React.FC<any> = (props) => {
  return isBrowser ? (
    <MapContainer className={styledMap} {...props.options}>
      {props.children}
    </MapContainer>
  ) : null;
};

export const HotelEmpty: React.FC<any> = (props) => {
  return (
    <div
      className={`${hotelEmpty} h-100 border rounded d-flex align-items-center p3`}
    >
      {props.children}
    </div>
  );
};
